import { Component, Input, ViewChild } from '@angular/core';
import { Table, TableModule } from 'primeng/table';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag'
import { LoaderService } from '../../services/loader/loader.service';


@Component({
  selector: 'lib-report-table',
  standalone: true,
  imports: [TableModule, InputIconModule, IconFieldModule,CommonModule,ButtonModule, TagModule],
  templateUrl: './report-table.component.html',
  styleUrl: './report-table.component.css'
})
export class ReportTableComponent {
 @ViewChild('dt') dt!: Table;
  @Input() data !: any[]
  @Input() header !: any [];
  @Input() saveData: boolean = false;

  loading: boolean = true;
  constructor(private router: Router, private _loader: LoaderService) {
    this._loader.isLoading.subscribe((res) => {
      this.loading = res
    });
   }

}
